import { BsGear, BsGraphUpArrow, BsHeart, BsHouseDoor, BsJournals, BsPeople, BsPerson, BsStar, BsTicketPerforated, BsTrash, BsWallet } from 'react-icons/bs';
import { FaBed, FaBus, FaCarRear } from 'react-icons/fa6';

// Primary menu items (left side - main navigation)
export const APP_MENU_ITEMS = [
  {
    key: 'services',
    label: 'Services',
    url: '/services'
  },
  {
    key: 'east-crete',
    label: 'East Crete',
    url: '/east-crete'
  },
  {
    key: 'about',
    label: 'About',
    url: '/about'
  }
];

// Secondary row — GetYourGuide-style plain text links (no mega menus)
export const mainPublicServiceNav = [
  { key: 'hotels', label: 'Hotels', url: '/hotels' },
  { key: 'excursions', label: 'Excursions', url: '/excursions' },
  { key: 'car-rental', label: 'Car Rental', url: '/car-rental' },
  { key: 'dmc-services', label: 'DMC Services', url: '/services' },
];

// Service menu items with icons (right side - category section)
export const serviceMenuItems = [
  {
    key: 'hotels',
    label: 'Hotels',
    url: '/hotels',
    icon: FaBed
  },
  {
    key: 'excursions',
    label: 'Excursions',
    url: '/excursions',
    icon: FaBus
  },
  {
    key: 'car-rental',
    label: 'Car Rental',
    url: '/car-rental',
    icon: FaCarRear
  }
];

// Keep the original for backward compatibility
export const bookingHomeMenuItems = serviceMenuItems;

// User profile menu items
export const USER_PROFILE_MENU_ITEMS = [
  {
    key: 'acc-user-profile',
    label: 'My Profile',
    url: '/user/profile',
    parentKey: 'acc-user',
    icon: BsPerson
  },
  {
    key: 'acc-user-bookings',
    label: 'My Bookings',
    url: '/user/bookings',
    parentKey: 'acc-user',
    icon: BsTicketPerforated
  },
  {
    key: 'acc-user-travelers',
    label: 'Travelers',
    url: '/user/travelers',
    parentKey: 'acc-user',
    icon: BsPeople
  },
  {
    key: 'acc-user-payment-details',
    label: 'Payment Details',
    url: '/user/payment-details',
    parentKey: 'acc-user',
    icon: BsWallet
  },
  {
    key: 'acc-user-wishlist',
    label: 'Wishlist',
    url: '/user/wishlist',
    parentKey: 'acc-user',
    icon: BsHeart
  },
  {
    key: 'acc-user-settings',
    label: 'Settings',
    url: '/user/settings',
    parentKey: 'acc-user',
    icon: BsGear
  },
  {
    key: 'acc-user-delete-profile',
    label: 'Delete Profile',
    url: '/user/delete-profile',
    parentKey: 'acc-user',
    icon: BsTrash
  }
];

// Agent menu items
export const AGENT_MENU_ITEMS = [
  {
    key: 'agent-dashboard',
    label: 'Dashboard',
    url: '/agent/dashboard',
    icon: BsHouseDoor
  },
  {
    key: 'agent-listings',
    label: 'Listings',
    url: '/agent/listings',
    icon: BsJournals
  },
  {
    key: 'agent-bookings',
    label: 'Bookings',
    url: '/agent/bookings',
    icon: BsTicketPerforated
  },
  {
    key: 'agent-activities',
    label: 'Activities',
    url: '/agent/activities',
    icon: BsGraphUpArrow
  },
  {
    key: 'agent-earnings',
    label: 'Earnings',
    url: '/agent/earnings',
    icon: BsWallet
  },
  {
    key: 'agent-reviews',
    label: 'Reviews',
    url: '/agent/reviews',
    icon: BsStar
  },
  {
    key: 'agent-settings',
    label: 'Settings',
    url: '/agent/settings',
    icon: BsGear
  }
];

// Admin menu items
export const ADMIN_MENU_ITEMS = [
  {
    key: 'admin-dashboard',
    label: 'Dashboard',
    url: '/admin/dashboard',
    icon: BsHouseDoor
  },
  {
    key: 'admin-bookings',
    label: 'Bookings',
    url: '/admin/bookings/list',
    icon: BsTicketPerforated
  },
  {
    key: 'admin-guests',
    label: 'Guests',
    url: '/admin/guests/list',
    icon: BsPeople
  },
  {
    key: 'admin-agents',
    label: 'Agents',
    url: '/admin/agents/list',
    icon: BsPeople
  },
  {
    key: 'admin-reviews',
    label: 'Reviews',
    url: '/admin/reviews',
    icon: BsStar
  },
  {
    key: 'admin-earnings',
    label: 'Earnings',
    url: '/admin/earnings',
    icon: BsWallet
  },
  {
    key: 'admin-settings',
    label: 'Settings',
    url: '/admin/settings',
    icon: BsGear
  }
];

// Help menu items
export const HELP_MENU_ITEMS = [
  {
    key: 'help-center',
    label: 'Help Center',
    url: '/help/center'
  },
  {
    key: 'help-detail',
    label: 'Help Detail',
    url: '/help/detail'
  },
  {
    key: 'help-privacy',
    label: 'Privacy Policy',
    url: '/help/privacy-policy'
  },
  {
    key: 'help-service',
    label: 'Terms of Service',
    url: '/help/service'
  }
];
